import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import tw, { css } from 'twin.macro'
import { Link, graphql } from 'gatsby'
import Img from 'gatsby-image'
import uniq from 'lodash.uniq'
import Layout from '../components/layout'
import Meta from '../components/meta'
import { ItemTable } from '../components/eco-swim/itemsTable'
import EcoSwimTable from '../components/eco-swim/ecoSwimTable'
import { AccordionIndex } from '../components/mineralswim/Accordion/AccordionIndex'
import steps from '../components/mineralswim/data/steps'
import ecoswimProcess from '../components/mineralswim/data/ecoswimProcess'

const EcoSwimPage = props => {
	const {
		pageData,
		slideData,
		mobileBannerImage,
		reasonsImage,
		moreThanImage,
		table,
		tabletBannerImage,
		chlorinatorImage,
		chlorinatorUnitImage,
		deadSeaMineralsImage,
		ozonePurificationImage,
		ecoswimOptimisationImage,
		unitImage,
	} = props.data
	const {
		seoTitle,
		seoKeywords,
		seoDescription,
		node_locale,
		slug,
	} = pageData.edges[0].node
	const slide = slideData.edges[0].node

	const [uniqSpec, setUniqSpec] = useState([])
	const [activeUnitPart, setActiveUnitPart] = useState('')
	const tblData = table.edges
	const specTtl = []
	tblData.map(x => {
		return x.node.specifications.map(a => {
			specTtl.push(a.spec)
		})
	})
	useEffect(() => {
		const unique = uniq(specTtl)
		setUniqSpec(unique)
	}, [])
	const { process1, process2, process3 } = ecoswimProcess
	const { step1, step4, step3 } = steps
	const changeActiveUnitPart = unitPart => {
		if (activeUnitPart === unitPart) {
			setActiveUnitPart('')
		} else {
			setActiveUnitPart(unitPart)
		}
	}

	const newObj = {
		name: tblData.map(x => x.node.model),
		countryAvailability: tblData.map(x => x.node.countryAvailability),
		specification: uniqSpec.map(x => {
			return {
				specttl: x,
				spec: [],
				ind: [],
			}
		}),
	}

	tblData.map(x => {
		return x.node.specifications.map(a => {
			return newObj.specification.map(c => {
				if (c.specttl === a.spec) {
					c.spec.push(a.detail ? a.detail : a.details)
				}
			})
		})
	})

	return (
		<Layout>
			<Meta
				title={seoTitle}
				description={seoDescription}
				keywords={seoKeywords}
				lang={node_locale}
				slug={slug}
			></Meta>
			<div tw="bg-white w-full">
				<div
					tw="relative z-20 w-full md:mb-14 lg:mb-24"
					css={css`
						height: 70vh !important;
						max-height: 767px !important;
						min-height: 400px !important;
						@media screen and (max-width: 380px) {
						height: 70vh !important;
						}
						@media (min-width: 450px) and (max-width: 767px) {
						height: 60vh !important;
						}
						@media (min-width: 768px) and (max-width: 819px) {
									height: 60vh !important;
								}
						@media (min-width: 820px) {
						min-height: 600px !important;
					`}
				>
					<div
						tw="absolute z-20 inset-0 h-full w-full"
						css={css`
							.gatsby-image-wrapper {
								width: 100% !important;
								height: 70vh !important;
								max-height: 767px !important;
								min-height: 400px !important;
								@media (min-width: 768px) and (max-width: 1023px) {
									height: 50vh !important;
								}
							}
							@media screen and (max-width: 380px) {
								height: 70vh !important;
							}
							@media (min-width: 380px) and (max-width: 768px) {
								height: 50vh !important;
							}
							img {
								object-position: 50% 0% !important;
							}
							@media screen and (max-width: 767px) {
								img {
									object-position: 50% 100% !important;
								}
							}
							@media (min-width: 768px) and (max-width: 1023px) {
								img {
									object-position: 50% 50% !important;
								}
							}
						`}
					>
						<Img
							{...slide.backgroundImage}
							tw="w-full hidden lg:block"
							loading="eager"
						/>
						<Img
							{...tabletBannerImage.nodes[0]}
							tw="w-full hidden sm:block lg:hidden"
							loading="eager"
						/>
						<Img
							{...mobileBannerImage.nodes[0]}
							tw="w-full sm:hidden"
							loading="eager"
						/>
					</div>
					<section tw="relative z-30 flex flex flex-col items-center w-full h-full max-w-screen-xl px-10 md:px-20 mx-auto py-12 sm:py-24">
						<div tw="w-full h-full flex justify-center md:justify-start">
							<div
								tw="flex flex-col h-full justify-center items-center space-x-2 text-gray-800 text-sm md:text-base xxl:pt-24"
								css={css`
									@media screen and (max-width: 768px) {
										color: #335979;
									}
								`}
							>
								<h1 tw="sm:text-white text-4xl md:text-5xl uppercase -mr-4">
									EcoSwim{' '}
									<span
										tw="text-lg md:text-xl -ml-3"
										style={{ verticalAlign: 'top' }}
									>
										®
									</span>
								</h1>
								<div tw="flex flex-col w-auto text-center items-end">
									<p tw="sm:text-white md:text-lg text-right whitespace-nowrap">
										NEXT-GEN SANITATION
									</p>
									<p tw="sm:text-white md:text-lg font-medium text-center mt-4 mb-6">
										Chlorination for a<br />
										Healthy Swimming Pool
									</p>
									<Link
										tw="text-white rounded-3xl px-4 py-2 md:py-2 shadow-md mb-2 uppercase text-2xs md:text-xs w-full"
										style={{ background: '#335979' }}
										to={slide.mainActionUrl}
									>
										{slide.mainActionText}
									</Link>
									<Link
										tw="bg-white text-blue-700 rounded-3xl px-4 py-2 md:py-2 shadow-md mb-2 uppercase text-2xs md:text-xs w-full"
										to={slide.secondActionUrl}
									>
										{slide.secondActionText}
									</Link>
								</div>
							</div>
						</div>
						<div tw="w-full justify-center hidden sm:flex">
							<div
								tw="md:px-10"
								css={css`
									.gatsby-image-wrapper {
										height: 100%;
									}
									img {
										object-fit: contain !important;
										object-position: center !important;
									}
									height: 400px !important;
									max-width: 700px !important;
									width: 100%;
									@media screen and (max-width: 768px) {
										height: 300px;
									}
									@media (min-width: 1300px) and (max-width: 1500px) {
										@media (max-height: 760px) {
											margin-top: -7rem;
										}
									}
								`}
							>
								<Img {...chlorinatorImage.nodes[0]} />
							</div>
						</div>
					</section>
				</div>
			</div>

			<section
				tw="text-dolphin-gray z-30"
				css={css`
					@media (min-width: 800px) and (max-width: 1050px) {
						@media (min-height: 1000px) {
							margin-top: -9rem;
						}
					}
				`}
			>
				<div
					tw="w-full justify-center flex sm:hidden -mb-40"
					css={css`
						margin-top: -5rem;
						@media screen and (max-width: 380px) {
							margin-top: -11rem;
						}
						@media (min-width: 380px) and (max-width: 768px) {
							margin-top: -10rem;
						}
						@media (min-width: 1300px) {
							margin-top: 1rem;
						}
					`}
				>
					<div
						tw="z-20 px-10"
						css={css`
							.gatsby-image-wrapper {
								height: 100%;
							}
							img {
								object-fit: contain !important;
								object-position: center !important;
							}
							height: 400px !important;
							max-width: 700px !important;
							width: 100%;
							@media screen and (max-width: 768px) {
								height: 300px;
							}
						`}
					>
						<Img {...chlorinatorImage.nodes[0]} />
					</div>
				</div>
				<div tw="max-w-7xl mx-auto py-12 sm:pt-0 px-4 text-center sm:px-6 lg:px-8 xl:py-16">
					<div tw="space-y-8 sm:space-y-12">
						<div tw="text-center">
							<h2 tw="text-4xl sm:text-4xl font-display font-medium text-blue-500 md:text-center mb-3">
								WHAT IS ECOSWIM
								<span tw="text-lg md:text-xl" style={{ verticalAlign: 'top' }}>
									®
								</span>
								?
							</h2>
							<p>
								Ecoswim
								<span tw="text-xs" style={{ verticalAlign: 'top' }}>
									®
								</span>{' '}
								effectively converts salt or magnesium-rich Dead Sea Minerals in
								your swimming pool,
								<br tw="hidden lg:block" />
								into pure sanitiser, ensuring that 100% of your pool’s primary
								sanitation needs are met.
							</p>
						</div>
						<ul
							tw="mx-auto flex flex-row items-center sm:items-start justify-center w-full gap-y-8 md:gap-x-10 lg:gap-16 xl:gap-24"
							style={{ color: '#335979' }}
						>
							<li tw="space-y-4 w-32 flex flex-col">
								<AutoIcon
									tw="mx-auto h-20 w-20 lg:w-24 lg:h-24 mt-3 lg:mt-0 pt-2"
									fill="#335979"
									accent="#335979"
								/>
								<div tw="space-y-2">
									<div tw="font-medium text-sm mt-1 lg:mt-0">
										<h3>Auto self-cleaning cell function</h3>
									</div>
								</div>
							</li>
							<li tw="space-y-4 w-32 flex flex-col md:pt-4 lg:pt-0">
								<WaterIcon
									tw="mx-auto h-20 w-20 lg:w-24 lg:h-24"
									fill="#335979"
									accent="#335979"
								/>
								<div tw="space-y-2">
									<div tw="font-medium text-sm">
										<h3>
											Healthy pool
											<br />
											water sanitiser
										</h3>
									</div>
								</div>
							</li>
							<li tw="space-y-4 w-32 flex flex-col">
								<PHIcon
									tw="mx-auto h-20 w-20 lg:w-24 lg:h-24 mt-4 lg:mt-0"
									fill="#58C8DF"
									accent="#58C8DF"
								/>
								<div tw="space-y-2">
									<div tw="font-medium text-sm" style={{ color: '#58C8DF' }}>
										<h3>
											Ozone & pH
											<br />
											Balancer Module
											<br />
											Ready
										</h3>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</section>

			<section id="reasons" tw="w-full bg-white text-gray-800">
				<div
					tw="relative w-full"
					css={css`
						height: calc(60vh - 33px);
						max-height: 767px;
						img {
							object-position: 50% 45% !important;
							@media screen and (max-width: 450px) {
								object-position: 0% 60% !important;
							}
							@media (min-width: 451px) and (max-width: 780px) {
								object-position: 45% 60% !important;
							}
						}
					`}
				>
					<Img {...reasonsImage.nodes[0]} tw="w-full h-full" />
					<div tw="absolute top-0 z-10 w-full h-full">
						<div tw="max-w-screen-lg mx-auto flex items-center pl-10 h-full pb-10 md:pb-20">
							<h3 tw="text-3xl md:text-4xl" style={{ color: '#335979' }}>
								REASONS
								<br />
								WHY POOL
								<br />
								OWNERS LOVE
								<br />
								ECOSWIM
								<span tw="text-lg md:text-xl" style={{ verticalAlign: 'top' }}>
									®
								</span>
							</h3>
						</div>
					</div>
				</div>
			</section>
			<div tw="flex flex-col w-full max-w-screen-lg mx-auto md:px-6 lg:px-8 pt-12 lg:pt-16">
				<div tw="text-center text-sm px-4">
					<p>
						The Australian-designed EcoSwim
						<span tw="text-xs" style={{ verticalAlign: 'top' }}>
							®
						</span>{' '}
						Chlorinator is packed with features that make it a favorite among
						pool owners.
					</p>
					<p tw="mt-4 md:mt-0">
						Its modular system allows for seamless upgrades, offering enhanced
						water quality and improved functionality.
					</p>
				</div>
				<div tw="w-full h-full md:-mt-16 md:-mb-10">
					<ItemTable />
				</div>
			</div>

			<section
				css={tw`relative w-full bg-blue-500 pt-12 pb-20 md:pt-20 px-8 text-white sm:px-6 lg:px-8 lg:py-24`}
			>
				<div tw="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-4 mb-10">
					<div tw="flex lg:pl-28">
						<h3 tw="text-4xl lg:text-4xl md:mt-10 lg:mt-20 ml-6 sm:ml-16 lg:ml-0">
							<span tw="whitespace-nowrap">HOW DOES</span>
							<br />
							ECOSWIM
							<span tw="text-lg md:text-xl" style={{ verticalAlign: 'top' }}>
								®
							</span>
							<br />
							WORK
						</h3>
					</div>
					<div tw="relative md:col-span-3 text-center sm:-mr-20 lg:-mr-10">
						<div tw="relative flex w-full">
							<div
								tw=""
								css={css`
									.gatsby-image-wrapper {
										height: 100%;
									}
									img {
										object-fit: contain !important;
										object-position: center !important;
									}
									height: 450px !important;
									width: 100%;
									@media screen and (max-width: 768px) {
										height: 200px !important;
									}
								`}
							>
								<Img {...unitImage.nodes[0]} />
							</div>
							<div
								onClick={() => changeActiveUnitPart('1')}
								tw="h-8 w-8 sm:h-10 sm:w-10 flex justify-center items-center rounded-full absolute text-white border-2 border-white text-base sm:text-lg font-bold"
								css={css`
									transition: transform 0.3s ease-in-out;
									&:hover {
										cursor: pointer;
										transform: scale(125%);
										background: #58c8df;
									}
									${activeUnitPart === '1'
										? 'background: #58C8DF; transform: scale(125%);'
										: 'background: #335979;'}
									top: 10%;
									left: 15%;
									@media screen and (max-width: 450px) {
										left: 5%;
									}
									@media (min-width: 451px) and (max-width: 810px) {
										left: 25%;
									}
								`}
							>
								1
							</div>
							<div
								onClick={() => changeActiveUnitPart('2')}
								tw="text-base h-8 w-8 sm:h-10 sm:w-10 flex justify-center items-center rounded-full absolute text-white border-2 border-white sm:text-lg font-bold"
								css={css`
									transition: transform 0.3s ease-in-out;
									&:hover {
										cursor: pointer;
										transform: scale(125%);
										background: #58c8df;
									}
									${activeUnitPart === '2'
										? 'background: #58C8DF; transform: scale(125%);'
										: 'background: #335979;'}
									top: 50%;
									left: 40%;
									@media screen and (max-width: 450px) {
										top: 55%;
										left: 35%;
									}
									@media (min-width: 451px) and (max-width: 810px) {
										top: 58%;
									}
								`}
							>
								2
							</div>
							<div
								onClick={() => changeActiveUnitPart('3')}
								tw="text-base h-8 w-8 sm:h-10 sm:w-10 flex justify-center items-center rounded-full absolute text-white border-2 border-white sm:text-lg font-bold"
								css={css`
									transition: transform 0.3s ease-in-out;
									&:hover {
										cursor: pointer;
										transform: scale(125%);
										background: #58c8df;
									}
									${activeUnitPart === '3'
										? 'background: #58C8DF; transform: scale(125%);'
										: 'background: #335979;'}
									top: 60%;
									left: 27%;
									@media screen and (max-width: 450px) {
										top: 60%;
										left: 20%;
									}
								`}
							>
								3
							</div>
							<div
								onClick={() => changeActiveUnitPart('4')}
								tw="text-base h-8 w-8 sm:h-10 sm:w-10 flex justify-center items-center rounded-full absolute text-white border-2 border-white sm:text-lg font-bold"
								css={css`
									transition: transform 0.3s ease-in-out;
									&:hover {
										cursor: pointer;
										transform: scale(125%);
										background: #58c8df;
									}
									${activeUnitPart === '4'
										? 'background: #58C8DF; transform: scale(125%);'
										: 'background: #335979;'}
									top: 63%;
									left: 68%;
									@media screen and (max-width: 450px) {
										top: 63%;
										left: 72%;
									}
								`}
							>
								4
							</div>
							<div
								onClick={() => changeActiveUnitPart('5')}
								tw="text-base h-8 w-8 sm:h-10 sm:w-10 flex justify-center items-center rounded-full absolute text-white border-2 border-white sm:text-lg font-bold"
								css={css`
									transition: transform 0.3s ease-in-out;
									&:hover {
										cursor: pointer;
										transform: scale(125%);
										background: #58c8df;
									}
									${activeUnitPart === '5'
										? 'background: #58C8DF; transform: scale(125%);'
										: 'background: #335979;'}
									top: 35%;
									left: 40%;
									@media screen and (max-width: 450px) {
										top: 35%;
										left: 35%;
									}
								`}
							>
								5
							</div>
						</div>
					</div>
				</div>
				<div
					css={tw`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-2 gap-x-4 max-w-screen-xl mx-auto px-2 md:px-10 lg:px-20 xl:px-24 xl:pr-36`}
				>
					<div
						css={tw`md:mt-14 md:mt-0 flex flex-col space-y-6 text-lg font-sans px-1`}
					>
						<div css={tw`text-sm`}>
							<AccordionIndex
								items={process1}
								backGroundColor={'bg-gray-800'}
								activeBackGroundColor={'bg-white'}
								withIndex={true}
								related={true}
								setActiveTab={changeActiveUnitPart}
								activeTab={activeUnitPart}
							/>
						</div>
					</div>
					<div
						css={tw`md:mt-14 md:mt-0 flex flex-col space-y-6 text-lg font-sans px-1`}
					>
						<div css={tw`text-sm`}>
							<AccordionIndex
								items={process2}
								backGroundColor={'bg-gray-800'}
								activeBackGroundColor={'bg-white'}
								withIndex={true}
								related={true}
								setActiveTab={changeActiveUnitPart}
								activeTab={activeUnitPart}
							/>
						</div>
					</div>
					<div
						css={tw`md:mt-14 md:mt-0 flex flex-col space-y-6 text-lg font-sans px-1`}
					>
						<div css={tw`text-sm`}>
							<AccordionIndex
								items={process3}
								backGroundColor={'bg-gray-800'}
								activeBackGroundColor={'bg-white'}
								withIndex={true}
								related={true}
								setActiveTab={changeActiveUnitPart}
								activeTab={activeUnitPart}
							/>
						</div>
					</div>
				</div>
				<div tw="flex justify-center mt-14 text-black">
					<a
						href="https://assets.ctfassets.net/ftcnv5up9dxv/WlkaJNtk5VSIZnXccXG8H/b8e98da1fe82474109d4106ff9737a1a/EcoSwim_Chlorinator_Landscape_ONLINE_80-050-1022.pdf"
						rel="noreferrer"
						target="_blank"
					>
						<button tw="text-sm md:text-base uppercase border border-black rounded-3xl px-14 md:px-20 py-2 md:py-3">
							Download Brochure
						</button>
					</a>
				</div>
			</section>
			<section
				id="find-the-right-system"
				tw="bg-white py-12 px-6 lg:px-8 lg:py-16"
			>
				<div tw="max-w-screen-lg mx-auto">
					<div tw="grid grid-cols-1 lg:grid-cols-12 gap-x-10 sm:px-10 lg:px-0">
						<div tw="w-full lg:col-span-5">
							<h2 tw="text-3xl sm:text-4xl text-blue-500">
								EXPLORE THE
								<br />
								RIGHT ECOSWIM
								<span tw="text-lg md:text-xl" style={{ verticalAlign: 'top' }}>
									®
								</span>
								<br />
								SYSTEM FOR YOU
							</h2>
							<p tw="text-justify lg:text-left mt-3 lg:mt-0">
								Selecting the right Ecoswim
								<span tw="text-xs" style={{ verticalAlign: 'top' }}>
									®
								</span>{' '}
								Chlorinator is key to maintaining clean and healthy pool water.
								When making your choice, consider the size of your pool, usage
								frequency, and local climate. Ecoswim
								<span tw="text-xs" style={{ verticalAlign: 'top' }}>
									®
								</span>{' '}
								Chlorinators are designed and made in Australia, to be energy
								efficient and easy to integrate with your pool system, ensuring
								optimal performance and water quality with minimal effort.{' '}
								<br />
								*For tailored recommendations, consult your local pool
								professional to find the perfect model to suit your needs and
								region.
							</p>
							<div tw="flex mt-14 text-black">
								<a href="https://www.maytronics.com.au/en-ZA/ecoswim/shop" rel="noreferrer">
									<button tw="text-sm md:text-base uppercase border border-black rounded-3xl px-14 md:px-20 py-2 md:py-3 mx-auto lg:ml-0 mb-12 lg:mb-0">
										FIND THE RIGHT SYSTEM
									</button>
								</a>
							</div>
						</div>
						<div tw="lg:col-span-7 overflow-x-auto">
							<EcoSwimTable />
						</div>
					</div>
				</div>
			</section>

			<div
				tw="relative w-full"
				css={css`
						height: calc(70vh - 33px);
						max-height: 767px;
						img {
							object-position: 50% 45% !important;
							@media screen and (max-width: 850px) {
							object-position: 0% 60% !important;
							}
					`}
			>
				<Img
					{...moreThanImage.nodes[0]}
					tw="w-full h-full"
					imgStyle={{ objectPosition: '50% 45%' }}
				/>
				<div tw="absolute top-0 z-10 w-full h-full">
					<div tw="max-w-screen-lg mx-auto flex flex-col justify-center sm:items-center lg:items-start h-full md:px-10 px-6 pt-10 sm:pt-0 lg:pt-10 lg:pt-16">
						<h3 tw="text-4xl md:text-4xl">
							MORE THAN A
							<br />
							CHLORINATOR
						</h3>
						<p>
							MAKE YOUR CHLORINATOR MORE
							<br />
							POWERFUL WITH MAYTRONICS
							<br />
							EASY UPGRADES
						</p>

						<div tw="flex sm:justify-center lg:justify-start w-full -ml-2 sm:-ml-10 lg:-ml-20">
							<div
								tw=""
								css={css`
									.gatsby-image-wrapper {
										height: 100%;
									}
									img {
										object-fit: contain !important;
										object-position: center !important;
									}
									height: 300px !important;
									max-width: 400px !important;
									width: 100%;
									@media screen and (max-width: 768px) {
										height: 200px;
									}
								`}
							>
								<Img {...chlorinatorUnitImage.nodes[0]} />
							</div>
						</div>
					</div>
				</div>
			</div>

			<section tw="max-w-screen-lg mx-auto px-4 sm:px-14 lg:px-0 py-12 sm:py-16 lg:mb-56">
				<div tw="w-full">
					<h2 tw="text-3xl sm:text-4xl text-blue-500">
						BOOST ECOSWIM
						<span tw="text-lg md:text-xl" style={{ verticalAlign: 'top' }}>
							®
						</span>{' '}
						PERFORMANCE WITH EASY UPGRADES.
					</h2>
					<p tw="text-xl mt-4 lg:mt-0 text-justify lg:text-left">
						More than just a chlorinator, the Ecoswim
						<span tw="text-sm" style={{ verticalAlign: 'top' }}>
							®
						</span>{' '}
						system can be enhanced with Maytronics’ easy upgrade solutions.
						Boost your Ecoswim
						<span tw="text-sm" style={{ verticalAlign: 'top' }}>
							®
						</span>{' '}
						system’s performance to better fit your needs. Whether you’re
						seeking increased output, advanced automation, or extra cleaning
						power, Maytronics upgrades offer the flexibility to make your
						Ecoswim
						<span tw="text-sm" style={{ verticalAlign: 'top' }}>
							®
						</span>{' '}
						system even more powerful and efficient.
					</p>
				</div>
			</section>

			<section
				css={tw`relative w-full md:pt-20 px-8 text-white sm:px-6 lg:px-8 pb-12 mb-2`}
				style={{ background: '#335979' }}
			>
				<div
					css={tw`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 max-w-screen-lg mx-auto`}
				>
					<div
						css={tw`space-y-6 text-lg mb-4 md:mb-0 md:mr-4 font-sans px-1 w-full`}
					>
						<div css={tw`leading-tight`}>
							<div tw="flex w-full sm:pb-4 lg:pb-8 -mt-4 lg:-mt-72 pl-14 sm:pl-20 lg:pl-0">
								<div
									tw="mx-auto"
									css={css`
										.gatsby-image-wrapper {
											height: 100%;
										}
										img {
											object-fit: contain !important;
											object-position: center !important;
										}
										height: 300px !important;
										max-width: 400px !important;
										width: 100%;
										@media screen and (max-width: 768px) {
											height: 200px;
										}
									`}
								>
									<Img {...deadSeaMineralsImage.nodes[0]} />
								</div>
							</div>
							<h3 css={tw`font-medium text-base uppercase text-blue-500`}>
								DEAD SEA MINERALS
							</h3>
						</div>
						<p tw="text-sm md:h-28 overflow-auto">
							Add Mineral Swim™ 100% Dead Sea Minerals for therapeutic benefits.
							Sourced directly from the Dead Sea, these magnesium-rich minerals
							promote health, skin, and overall wellness
						</p>
						<div css={tw`px-3 md:px-0 text-sm`}>
							<AccordionIndex
								items={step1}
								backGroundColor={'bg-blue-500'}
								activeBackGroundColor={'bg-white'}
							/>
						</div>
					</div>
					<div
						css={tw`mt-14 md:mt-0 flex flex-col space-y-6 text-lg mb-4 md:mb-0 md:mr-4 font-sans px-1`}
					>
						<div css={tw`leading-tight`}>
							<div tw="flex w-full lg:-mt-64 pl-6 sm:pl-10 lg:pl-0">
								<div
									tw="mx-auto"
									css={css`
										.gatsby-image-wrapper {
											height: 100%;
										}
										img {
											object-fit: contain !important;
											object-position: center !important;
										}
										height: 300px !important;
										max-width: 400px !important;
										width: 100%;
										@media screen and (max-width: 768px) {
											height: 200px;
										}
									`}
								>
									<Img {...ozonePurificationImage.nodes[0]} />
								</div>
							</div>
							<h3 css={tw`font-medium text-base uppercase text-blue-500`}>
								OZONE PURIFICATION
							</h3>
						</div>
						<p tw="text-sm md:h-28 overflow-auto">
							Add the Mineral Swim™ V2 Purifier Module to deliver power ozone
							purification. This will allow you to dial down chlorine
							production, which is safer, softer, and kinder to sensitive skin,
							hair, and eyes.
						</p>
						<div css={tw`px-3 md:px-0 text-sm`}>
							<AccordionIndex
								items={step3}
								backGroundColor={'bg-blue-500'}
								activeBackGroundColor={'bg-white'}
							/>
						</div>
					</div>
					<div
						css={tw`mt-14 lg:mt-0 flex flex-col space-y-6 text-lg mb-4 md:mb-0 md:mr-4 font-sans px-1`}
					>
						<div css={tw`leading-tight`}>
							<div tw="flex w-full pb-8 -mb-4 pt-4 lg:-mt-72" css="">
								<div
									tw="mx-auto"
									css={css`
										.gatsby-image-wrapper {
											height: 100%;
										}
										img {
											object-fit: contain !important;
											object-position: center !important;
										}
										height: 300px !important;
										max-width: 400px !important;
										width: 100%;
										@media screen and (max-width: 768px) {
											height: 200px;
										}
									`}
								>
									<Img {...ecoswimOptimisationImage.nodes[0]} />
								</div>
							</div>
							<h3 css={tw`font-medium text-base uppercase text-blue-500`}>
								ECOSWIM
								<span tw="text-sm" style={{ verticalAlign: 'top' }}>
									®
								</span>{' '}
								OPTIMISATIONS
							</h3>
						</div>
						<p tw="text-sm md:h-28 overflow-auto">
							Enhance your Ecoswim
							<span tw="text-xs" style={{ verticalAlign: 'top' }}>
								®
							</span>{' '}
							experience with optional upgrades and streamline your pool
							maintenance routine. Explore Maytronics range of optimisations.
						</p>
						<div css={tw`px-3 md:px-0 text-sm`}>
							<AccordionIndex
								items={step4}
								backGroundColor={'bg-blue-500'}
								activeBackGroundColor={'bg-white'}
							/>
						</div>
					</div>
				</div>

				<div tw="flex justify-center mt-14 text-black">
					<a href="/en-ZA/support/find-a-dealer/" rel="noreferrer">
						<button tw="text-base uppercase bg-white rounded-3xl px-20 py-3">
							FIND A SUPPLIER
						</button>
					</a>
				</div>
			</section>

		</Layout>
	)
}

export const EcoSwimPageQuery = graphql`
	query ecoSwimPageQueryZA {
		pageData: allContentfulPage(
			filter: {
				contentful_id: { eq: "67iI430apW9R3NYGGQJIbY" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			edges {
				node {
					seoTitle
					seoKeywords
					seoDescription
					node_locale
					slug
					body {
						json
					}
					frequentlyAskedQuestions {
						title
						slug
						faqCategory
					}
				}
			}
		}
		slideData: allContentfulBanner(
			filter: {
				identifier: { regex: "/slide-eco-swim-/" }
				node_locale: { eq: "en-ZA" }
			}
			sort: { fields: identifier, order: ASC }
		) {
			edges {
				node {
					hook
					backgroundImage {
						title
						alt: description
						fluid(maxWidth: 1600, maxHeight: 900, quality: 70) {
							...GatsbyContentfulFluid_withWebp
						}
					}
					objectPosition: background
					mainActionText
					mainActionUrl
					secondActionText
					secondActionUrl
					thirdActionText
					downloads {
						file {
							url
						}
					}
				}
			}
		}
		reasonsImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "2SHbSIz38BEvZ1dfocOGgm" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1600, maxHeight: 900, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		moreThanImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "MC8OOxJL5RBeQGxBGUHWy" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1600, maxHeight: 900, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		warrantyImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5e7G9jgx5rJ4EjvgGsruGv" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1600, maxHeight: 900, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		moreImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "3veCiE27AUQmlczw8rG7j4" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1600, maxHeight: 900, quality: 80) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		table: allContentfulProduct(
			filter: {
				contentful_id: {
					in: [
						"7cQG9AvXhSW8dp98qjEmTm"
						"2k7qeHCupfEEHrAPVccB7r"
						"jspbqtFBfmSAmThzcBsbD"
					]
				}
				node_locale: { eq: "en-ZA" }
			}
			sort: { fields: popularity, order: ASC }
		) {
			edges {
				node {
					seoTitle
					model
					node_locale
					countryAvailability
					specifications {
						spec
						detail
						details
					}
				}
			}
		}
		systemImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "Jwk7WM1krtaDMp9yf9xkV" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 250, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		mineralsImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5sQO2IdeAD0AiK8ZPWjEPb" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 250, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		phControlImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6E45H09MFZoTCxpSmh30wQ" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 250, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		cleanerImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "4JPYUN2nsnGDmINK5gIGLn" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 300, maxHeight: 250, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		chlorinatorImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5C1aPOAyufRsB7DFMPCzNj" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1478, maxHeight: 800, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		chlorinatorUnitImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "3wwVmDEjU9xN60AARiGqy3" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1478, maxHeight: 800, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		mobileBannerImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "7EbphUBmSzJ2mLzqiI6i2h" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 500, maxHeight: 500, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		tabletBannerImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "G8MqWN0HcnpNfRblMVv3K" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 800, maxHeight: 800, quality: 90) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		deadSeaMineralsImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "5qNeFqIZyIAIys2RAoGS3A" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1478, maxHeight: 800, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		ozonePurificationImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "VjQnKaLJPlcNo8IyW5DgO" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1478, maxHeight: 800, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		ecoswimOptimisationImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "60O3BzIVvGM3LuXBnNGKhx" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1478, maxHeight: 800, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		unitImage: allContentfulAsset(
			filter: {
				contentful_id: { eq: "6e8F7ACgUQBDczvlAGIGU" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			nodes {
				title
				alt: description
				fluid(maxWidth: 1000, maxHeight: 600, quality: 70) {
					...GatsbyContentfulFluid_withWebp
				}
			}
		}
		formData: allContentfulForm(
			filter: {
				contentful_id: { eq: "572hm1Bf84LbciXyk8xRrH" }
				node_locale: { eq: "en-ZA" }
			}
		) {
			edges {
				node {
					title
					description
					endpoint
					node_locale
					items {
						... on ContentfulFormField {
							helpText
							inputAutocomplete
							inputId
							inputName
							inputPlaceholder
							inputRequired
							inputType
							textareaCols
							textareaRows
							icon
							validationText
							width
							options
							node_locale
							label
						}
						... on ContentfulFormGroup {
							title
							items {
								width
								validationText
								textareaRows
								textareaCols
								options
								node_locale
								label
								inputType
								inputRequired
								inputPlaceholder
								inputName
								inputId
								inputAutocomplete
								icon
								helpText
							}
						}
					}
				}
			}
		}
	}
`

export default EcoSwimPage

EcoSwimPage.propTypes = {
	data: PropTypes.shape({
		pageData: PropTypes.objectOf(PropTypes.array),
		slideData: PropTypes.objectOf(PropTypes.array),
		reasonsImage: PropTypes.object,
		moreThanImage: PropTypes.object,
		warrantyImage: PropTypes.object,
		chlorinatorImage: PropTypes.object,
		chlorinatorUnitImage: PropTypes.object,
		deadSeaMineralsImage: PropTypes.object,
		ozonePurificationImage: PropTypes.object,
		ecoswimOptimisationImage: PropTypes.object,
		mobileBannerImage: PropTypes.object,
		tabletBannerImage: PropTypes.object,
		unitImage: PropTypes.object,
		moreImage: PropTypes.object,
		table: PropTypes.object,
		systemImage: PropTypes.object,
		cleanerImage: PropTypes.object,
		mineralsImage: PropTypes.object,
		phControlImage: PropTypes.object,
		formData: PropTypes.object,
	}),
	location: PropTypes.shape({
		search: PropTypes.string,
	}),
}

export const OzoneSwimTag = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 479.43 141.73"
		fill="currentColor"
		{...props}
	>
		<title>Ozone Swim - Exceptional Pool Purification</title>
		<path d="M59.06,108.21c-2.34,0-2.74.46-2.74,2.6V113h6.91v2.28H56.32v2.5c0,2.13.4,2.6,2.74,2.6h4.5v2.23c-1.23,0-3.26.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.75-4,5.73-4,1.17,0,3.2,0,4.43.11v2.23Z" />
		<path d="M80.21,122.69H76.84L73,116.52l-3.76,6.17H66l5.44-8.54-5.24-8.24h3.33l3.58,5.82,3.61-5.82H79.9l-5.2,8.14Z" />
		<path d="M92.39,108.42a21.82,21.82,0,0,0-3.3-.27c-4.51,0-4.54,2.6-4.54,6.15s0,6.15,4.54,6.15a21.82,21.82,0,0,0,3.3-.27l.26,2.22a17.93,17.93,0,0,1-4.21.46c-5.53,0-6.89-2.61-6.89-8.56s1.37-8.56,6.89-8.56a17.93,17.93,0,0,1,4.21.46Z" />
		<path d="M101,108.21c-2.34,0-2.73.46-2.73,2.6V113h6.91v2.28H98.29v2.5c0,2.13.39,2.6,2.73,2.6h4.5v2.23c-1.22,0-3.25.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.76-4,5.73-4,1.18,0,3.21,0,4.43.11v2.23Z" />
		<path d="M111.77,122.69h-2.92V106.17a32.66,32.66,0,0,1,5.36-.43c3.69,0,6.67.73,6.67,5.23s-2.68,5.33-6.48,5.33c-.86,0-1.86,0-2.63-.09Zm0-8.76a19.84,19.84,0,0,0,2.44.11c2.42,0,3.77-.62,3.77-3.07,0-2.14-.92-3-3.69-3a19.76,19.76,0,0,0-2.52.17Z" />
		<path d="M134.17,105.91v2.32H129.9v14.46H127V108.23H122.7v-2.32Z" />
		<path d="M136.72,122.69V105.91h2.94v16.78Z" />
		<path d="M149.62,122.86c-5.17,0-6.65-2.48-6.65-8.56s1.48-8.56,6.65-8.56,6.64,2.48,6.64,8.56S154.79,122.86,149.62,122.86Zm0-2.37c3.57,0,3.67-2.53,3.67-6.19s-.1-6.2-3.67-6.2-3.67,2.53-3.67,6.2S146.05,120.49,149.62,120.49Z" />
		<path d="M170.05,119V105.91h2.61v14.82c0,1.49-.66,2.13-1.8,2.13s-1.86-.49-2.59-1.88l-6.06-11.47v13.18H159.6V107.86c0-1.49.68-2.12,1.8-2.12s1.86.49,2.58,1.87Z" />
		<path d="M175.14,122.69l5.08-15a2.58,2.58,0,0,1,5,0l5,15h-3.11l-1.42-4.46h-6.18l-1.39,4.46ZM185,116l-2.42-7.59L180.24,116Z" />
		<path d="M195.49,117.79c0,2.13.39,2.6,2.73,2.6h4.22v2.24c-1.24.05-3.06.1-4.15.1-3,0-5.73-.16-5.73-4V105.91h2.93Z" />
		<path d="M213.71,122.69h-2.92V106.17a32.66,32.66,0,0,1,5.36-.43c3.69,0,6.67.73,6.67,5.23s-2.68,5.33-6.48,5.33c-.86,0-1.86,0-2.63-.09Zm0-8.76a19.84,19.84,0,0,0,2.44.11c2.42,0,3.77-.62,3.77-3.07,0-2.14-.92-3-3.69-3a19.76,19.76,0,0,0-2.52.17Z" />
		<path d="M231.93,122.86c-5.17,0-6.65-2.48-6.65-8.56s1.48-8.56,6.65-8.56,6.64,2.48,6.64,8.56S237.1,122.86,231.93,122.86Zm0-2.37c3.57,0,3.67-2.53,3.67-6.19s-.1-6.2-3.67-6.2-3.66,2.53-3.66,6.2S228.36,120.49,231.93,120.49Z" />
		<path d="M248.1,122.86c-5.17,0-6.65-2.48-6.65-8.56s1.48-8.56,6.65-8.56,6.64,2.48,6.64,8.56S253.27,122.86,248.1,122.86Zm0-2.37c3.57,0,3.67-2.53,3.67-6.19s-.1-6.2-3.67-6.2-3.67,2.53-3.67,6.2S244.52,120.49,248.1,120.49Z" />
		<path d="M261,117.79c0,2.13.4,2.6,2.74,2.6h4.21v2.24c-1.24.05-3.06.1-4.15.1-3,0-5.73-.16-5.73-4V105.91H261Z" />
		<path d="M279.17,122.69h-2.92V106.17a32.66,32.66,0,0,1,5.36-.43c3.69,0,6.68.73,6.68,5.23s-2.68,5.33-6.49,5.33c-.85,0-1.86,0-2.63-.09Zm0-8.76a19.84,19.84,0,0,0,2.44.11c2.42,0,3.77-.62,3.77-3.07,0-2.14-.92-3-3.69-3a19.76,19.76,0,0,0-2.52.17Z" />
		<path d="M293.84,117.3c0,2.23.89,3.14,3.34,3.14s3.33-.91,3.33-3.14V105.91h2.89v11.21c0,4.55-2.46,5.74-6.22,5.74s-6.23-1.19-6.23-5.74V105.91h2.89Z" />
		<path d="M310,122.69H307.1V106.17a32.66,32.66,0,0,1,5.36-.43c3.64,0,6.67.72,6.67,5.17,0,3.06-1.37,4.42-3.49,5l3.92,6.82h-3.4l-3.57-6.52c-.85,0-1.83,0-2.57-.09Zm0-8.9a19.84,19.84,0,0,0,2.44.11c2.37,0,3.77-.6,3.77-3,0-2.1-1-2.92-3.69-2.92a19.72,19.72,0,0,0-2.52.16Z" />
		<path d="M322.38,122.69V105.91h2.94v16.78Z" />
		<path d="M329,122.69V109.83c0-3.81,2.76-4,5.74-4,1.17,0,3.2,0,4.42.11v2.23h-4.5c-2.34,0-2.73.46-2.73,2.6V113h6.91v2.28H332v7.4Z" />
		<path d="M341.8,122.69V105.91h2.94v16.78Z" />
		<path d="M358.84,108.42a21.93,21.93,0,0,0-3.3-.27c-4.51,0-4.55,2.6-4.55,6.15s0,6.15,4.55,6.15a21.93,21.93,0,0,0,3.3-.27l.26,2.22a18,18,0,0,1-4.22.46c-5.52,0-6.88-2.61-6.88-8.56s1.37-8.56,6.88-8.56a18,18,0,0,1,4.22.46Z" />
		<path d="M361.21,122.69l5.09-15a2.58,2.58,0,0,1,5,0l5,15h-3.11l-1.42-4.46h-6.18l-1.4,4.46ZM371.1,116l-2.41-7.59L366.31,116Z" />
		<path d="M387.54,105.91v2.32h-4.27v14.46h-2.94V108.23h-4.26v-2.32Z" />
		<path d="M390.09,122.69V105.91H393v16.78Z" />
		<path d="M403,122.86c-5.17,0-6.65-2.48-6.65-8.56s1.48-8.56,6.65-8.56,6.64,2.48,6.64,8.56S408.16,122.86,403,122.86Zm0-2.37c3.57,0,3.67-2.53,3.67-6.19s-.1-6.2-3.67-6.2-3.67,2.53-3.67,6.2S399.42,120.49,403,120.49Z" />
		<path d="M423.42,119V105.91H426v14.82c0,1.49-.66,2.13-1.8,2.13s-1.85-.49-2.59-1.88l-6.06-11.47v13.18H413V107.86c0-1.49.68-2.12,1.8-2.12s1.86.49,2.58,1.87Z" />
		<path
			d="M75.85,55.77c0,16.26-6.16,23.28-22.43,23.28S31,72,31,55.77s6.16-23.11,22.42-23.11S75.85,39.51,75.85,55.77ZM53.42,75c12.84,0,17.81-4.71,17.81-19.26s-5-19.09-17.81-19.09-17.8,4.54-17.8,19.09S40.59,75,53.42,75Z"
			fill="#58c8df"
		/>
		<path
			d="M80.64,74.69A7.44,7.44,0,0,1,82.87,70l26.19-30.81c.25-.35.68-.69.68-1.29s-.6-.68-.85-.68h-27v-4h29a3.72,3.72,0,0,1,3.94,3.69,6.4,6.4,0,0,1-1.46,3.68L86.12,72.8c-.26.35-.69.6-.69,1.2,0,.26.09.43.26.43l.51.08H115v4H86.2C84.15,78.54,80.64,78.11,80.64,74.69Z"
			fill="#58c8df"
		/>
		<path
			d="M164.6,55.77c0,16.26-6.16,23.28-22.42,23.28s-22.42-7-22.42-23.28,6.16-23.11,22.42-23.11S164.6,39.51,164.6,55.77ZM142.18,75C155,75,160,70.32,160,55.77s-5-19.09-17.8-19.09-17.8,4.54-17.8,19.09S129.34,75,142.18,75Z"
			fill="#58c8df"
		/>
		<path
			d="M172.31,40.36c0-4.36,1.37-7.19,6.16-7.19h16.69c9.41,0,13.09,5,13.09,14V78.54H203.8V47.13c0-5.48-1.79-9.93-8.64-9.93H179.5c-1.71,0-2.74.34-2.74,3.25V78.54h-4.45Z"
			fill="#58c8df"
		/>
		<path
			d="M231.62,78.54c-12.5,0-15.66-9.42-15.66-22.34,0-15.32,4.11-23.54,19.43-23.54,11.21,0,19.51,4.45,19.51,17.29,0,5.22-1.37,7.45-6.5,7.45H220.58c0,8,1.37,17.11,11,17.11h22.25v4ZM248.4,53.37a1.86,1.86,0,0,0,1.88-2v-.6c0-11.13-5.48-14-14.81-14-10.1,0-14.89,3.68-14.89,16.69Z"
			fill="#58c8df"
		/>
		<path d="M321.93,72.93q.18.43.39.9c.14.32.33.48.56.48s.48-.19.6-.56a4.68,4.68,0,0,1,.26-.73l9.52-36.72a4.54,4.54,0,0,1,2-3,4.51,4.51,0,0,1,4.63,0,4.59,4.59,0,0,1,2,3L351.36,73a6.75,6.75,0,0,1,.25.73c.12.37.32.56.6.56s.42-.16.56-.48.27-.61.39-.9l10.21-39.8h4.46l-11.15,42.2A7.82,7.82,0,0,1,355.35,78a3.65,3.65,0,0,1-3.05,1.16,4.51,4.51,0,0,1-2.06-.43,4.36,4.36,0,0,1-1.37-1,5.17,5.17,0,0,1-.81-1.24,4.39,4.39,0,0,1-.39-1.16L338.4,39.74a9.78,9.78,0,0,0-.38-1.12c-.14-.34-.3-.51-.47-.51s-.33.17-.48.51a9.78,9.78,0,0,0-.38,1.12l-9.27,35.51c-.11.34-.25.73-.42,1.16a4.5,4.5,0,0,1-.78,1.24,4.22,4.22,0,0,1-3.43,1.46,3.62,3.62,0,0,1-3-1.16,7.64,7.64,0,0,1-1.33-2.62l-11.15-42.2h4.46Z" />
		<path d="M372.46,19.21h4.8V25.9h-4.8Zm.17,13.92h4.46V78.59h-4.46Z" />
		<path d="M386.53,40.34a9.46,9.46,0,0,1,1.28-5.24q1.29-2,4.89-2h42.12q7.11,0,10.12,3.65t3,10.33V78.59h-4.46V47.18a18.76,18.76,0,0,0-.38-3.85,8.34,8.34,0,0,0-1.38-3.17A6.55,6.55,0,0,0,439.07,38a10.25,10.25,0,0,0-4.25-.77H419.47V78.59H415V37.25H393.73a3.43,3.43,0,0,0-2,.51c-.49.34-.73,1.26-.73,2.74V78.59h-4.46Z" />
		<path d="M288.29,4.38c-.55.6-1.08,1.08-1.53,1.66a18.45,18.45,0,0,0-3.7,13.34,22.31,22.31,0,0,0,2.73,8.6,79.1,79.1,0,0,0,5.38,8.37,96.12,96.12,0,0,1,7.33,11.77,18.85,18.85,0,0,1,2.22,9.74,16.81,16.81,0,0,1-2.56,7.93,17.24,17.24,0,0,1-2.62,3.35c-.1-.26,0-.33.12-.43a15.8,15.8,0,0,0,2.6-8.86,16.63,16.63,0,0,0-1.41-6.1A34.4,34.4,0,0,0,292,45.82c-2.57-3.3-5.37-6.29-8.1-9.37a73.09,73.09,0,0,1-6.39-7.93,24.67,24.67,0,0,1-3.16-6.18,13.26,13.26,0,0,1,.29-9.36,13.18,13.18,0,0,1,7.78-7.78A15.16,15.16,0,0,1,288,4.36Z" />
		<path
			d="M275.49,80.28a14.39,14.39,0,0,0,3.32-4.37,19.58,19.58,0,0,0,.93-15.24,32,32,0,0,0-3.7-7.32c-1.68-2.61-3.49-5.1-5.22-7.65a78.82,78.82,0,0,1-5.63-9.35c-2.53-5.16-2.89-10.28-.68-15.33a19.31,19.31,0,0,1,3.67-5.42c.06-.06.11-.14.25-.09A27.09,27.09,0,0,0,267,18a14.78,14.78,0,0,0-.83,10.83A24.62,24.62,0,0,0,269.11,35a48.83,48.83,0,0,0,3.38,4.67c2.37,2.94,4.9,5.66,7.38,8.45a78.92,78.92,0,0,1,5.6,6.79,28.73,28.73,0,0,1,3.73,6.62,13.25,13.25,0,0,1,.14,9.73,13.09,13.09,0,0,1-7.63,8.06,14.66,14.66,0,0,1-5.9,1Z"
			fill="#58c8df"
		/>
		<path d="M457.35,33.13a5.09,5.09,0,1,1-5.09,5.08A5.06,5.06,0,0,1,457.35,33.13Zm0,1a4.1,4.1,0,1,0,4,4.09A4,4,0,0,0,457.35,34.12Zm-.87,6.9H455.4V35.21h2.07c1.63,0,2.27.62,2.27,1.71a1.52,1.52,0,0,1-1.16,1.58L459.82,41h-1.21l-1.14-2.36h-1Zm0-4.9v1.63h.87c.91,0,1.33-.26,1.33-.83s-.45-.8-1.35-.8Z" />
	</svg>
)
export const AutoIcon = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 55.01 55.01"
		fill="currentColor"
		{...props}
	>
		<defs>
			<clipPath id="a" transform="translate(0 0)">
				<rect width="55.01" height="55.01" fill="none" />
			</clipPath>
		</defs>
		<g clipPath="url(#a)">
			<path
				d="M27.5,55A27.51,27.51,0,1,1,55,27.5,27.51,27.51,0,0,1,27.5,55m0-3.83A23.68,23.68,0,1,0,3.82,27.5,23.68,23.68,0,0,0,27.5,51.18"
				transform="translate(0 0)"
			/>
			<path
				d="M35.58,41.81c-.5-.56-1-1-1.37-1.55a.66.66,0,0,0-.93-.18c-5,2.21-9.62,1.59-14.09-1.55l2.06-2.61a10.22,10.22,0,0,0,10.28,1.35l-1.7-2,8.47-1.73-2.72,8.22"
				transform="translate(0 0)"
			/>
			<path
				d="M40.9,30.53,37.81,30a10.39,10.39,0,0,0-3.37-9.48l-.95,2.53L27.87,16.5l8.47-1.61a13,13,0,0,1-.51,1.56.91.91,0,0,0,.35,1.26,13.23,13.23,0,0,1,4.91,12.38,1.14,1.14,0,0,1-.06.25c0,.05-.06.09-.13.19"
				transform="translate(0 0)"
			/>
			<path
				d="M18.2,26.33l2.3-.43c-.93,2.79-1.82,5.43-2.74,8.21-2-2.2-3.8-4.31-5.65-6.41.11-.1.15-.17.19-.17,1.74,0,2.55-.71,2.91-2.6A12.46,12.46,0,0,1,22,16.16c.34-.18.71-.32,1.12-.51l1.21,3a10.35,10.35,0,0,0-6.17,7.64"
				transform="translate(0 0)"
			/>
		</g>
	</svg>
)

export const WaterIcon = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 283.46 283.46"
		fill="currentColor"
		{...props}
	>
		<path
			d="M141.73,253.29c61.61,0,111.56-49.95,111.56-111.56c0-61.61-49.95-111.56-111.56-111.56
			c-61.62,0-111.56,49.95-111.56,111.56C30.17,203.35,80.11,253.29,141.73,253.29L141.73,253.29z M141.73,271.3
			c-71.56,0-129.57-58.01-129.57-129.57c0-71.56,58.01-129.57,129.57-129.57c71.55,0,129.57,58.01,129.57,129.57
			C271.3,213.29,213.29,271.3,141.73,271.3L141.73,271.3z"
		/>
		<rect x="133.54" y="151.28" width="9.9" height="9.9" />
		<path
			d="M138.49,85.72c0,0-38.08,61.73-38.08,81.48c0,19.76,17.05,35.78,38.08,35.78s38.08-16.02,38.08-35.78
			C176.58,147.44,138.49,85.72,138.49,85.72z M164.11,161.18h-20.67v20.67h-9.9v-20.67h-20.67v-9.9h20.67v-20.67h9.9v20.67h20.67
			V161.18z"
		/>
		<path d="M172.15,107.53h-5.23V80.49h5.23V107.53z M183.06,96.63V91.4h-27.05v5.23H183.06z" />
	</svg>
)
export const PHIcon = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="220 0 150 350"
		fill="currentColor"
		{...props}
	>
		<path d="M296.6,34.6c-76.2,0-138.2,62-138.2,138.2s62,138.2,138.2,138.2,138.2-62,138.2-138.2-62-138.2-138.2-138.2M296.6,334.8c-89.3,0-161.9-72.6-161.9-161.9S207.3,10.9,296.6,10.9s161.9,72.6,161.9,161.9-72.6,161.9-161.9,161.9" />
		<path d="M372.8,265.2h0s0,0,0,0Z" />
		<path d="M269.7,142.8c-1.8,0-4-.4-5.6-.9v-18.2c0-1.8,0-3.8.2-5.4,1.5-.7,4.1-1.1,6.3-1.1,8.6,0,9,6.2,9,12.8s-.3,12.7-9.8,12.7M270.6,109.5c-5.5,0-11.7,1.1-16.2,3.7-.2,2.6-.3,4.9-.3,7.6v44.2h10v-15.1c2.4.5,5.2.9,7.7.9,12.4,0,17.9-5.1,17.9-20.6s-5.6-20.6-19-20.6" />
		<polygon points="328.4 119 309.5 119 309.5 97.6 298.8 97.6 298.8 150.2 309.5 150.2 309.5 127.7 328.4 127.7 328.4 150.2 339.1 150.2 339.1 97.6 328.4 97.6 328.4 119" />
		<g>
			<path d="M321.9,233.4c-10.5,0-10.7-8.8-10.7-22s.3-22,10.7-22,10.7,8.8,10.7,22-.2,22-10.7,22M321.9,179.1c-19.6,0-23.7,10.6-23.7,32.3s4,32.3,23.7,32.3,23.6-10.6,23.6-32.3-4-32.3-23.6-32.3" />
			<path d="M360.5,236.8c1.8-1,2.7-2.7,2.7-4.6,0-4.6-3.8-5.5-7.9-5.5s-4.7.4-6.6.7l.5,3.6c2-.3,4-.5,5.8-.5s3.3.2,3.3,2.1-.5,2.1-1.7,2.3c-1.4.2-3,.4-4.9.4v3.5h.7c1.9,0,3.1,0,4.3.2,1.3.2,1.9.9,1.9,2.4,0,2.3-1.3,2.7-4.1,2.7s-3.6-.2-5.4-.5l-.5,3.6c2.2.4,4.3.8,6.7.8,5.2,0,8.3-1.6,8.3-6.7s-1-3.6-3-4.5" />
		</g>
		<rect x="261.8" y="208.4" width="21.6" height="10.4" />
		<rect x="251.5" y="186.8" width="10.4" height="21.6" />
		<rect x="251.5" y="218.8" width="10.4" height="21.6" />
		<rect x="229.8" y="208.4" width="21.6" height="10.4" />
	</svg>
)
export const WaterPlusIcon = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 105.67 150.7"
		fill="currentColor"
		stroke="currentColor"
		{...props}
	>
		<defs>
			<clipPath id="a" transform="translate(0 0)">
				<rect width="105.67" height="150.7" fill="none" />
			</clipPath>
		</defs>
		<g clipPath="url(#a)">
			<path
				d="M52.27,2.52S-30.38,82.65,16,132.24c0,0,35.57,37.36,74.38,0S73.83,21.21,52.27,2.52Z"
				transform="translate(0 0)"
				fill="none"
				stroke="#fff"
				strokeMiterlimit="10"
				strokeWidth="3.72"
			/>
			<path
				d="M74,132.88s24-14.5,18.59-48.74c0,0-.9-7.38,3.17.74s4.88,42.52-21.76,48"
				transform="translate(0 0)"
				fill="#fff"
			/>
			<path
				d="M52,60.41s-7,19.37-12.33,24.67-20.8,11.54-20.8,11.54,15.49,6,20.8,11.34,12.44,22.66,12.44,22.66S58.15,113.27,63.44,108,85.2,96.62,85.2,96.62,68.75,90.46,63.44,85.16,52,60.41,52,60.41"
				transform="translate(0 0)"
				fill="#fff"
			/>
		</g>
		<rect x="39.83" y="93.58" width="10.4" height="3.58" fill="#353e47" />
		<rect x="53.81" y="93.58" width="10.4" height="3.58" fill="#353e47" />
		<rect x="50.22" y="83.1" width="3.58" height="10.48" fill="#353e47" />
		<rect x="50.22" y="97.16" width="3.58" height="10.51" fill="#353e47" />
		<rect x="50.22" y="93.58" width="3.58" height="3.58" fill="#fff" />
		<rect x="67.69" y="68.22" width="7.99" height="2.75" fill="#fff" />
		<rect x="78.43" y="68.22" width="7.99" height="2.75" fill="#fff" />
		<rect x="75.67" y="60.17" width="2.75" height="8.05" fill="#fff" />
		<rect x="75.67" y="70.97" width="2.75" height="8.07" fill="#fff" />
		<rect x="75.67" y="68.22" width="2.75" height="2.75" fill="#353e47" />
	</svg>
)
export const MineralSwimTag = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 518.19 141.73"
		fill="currentColor"
		{...props}
	>
		<title>Mineral Swim - Experience the Dead Sea</title>
		<path d="M114.36,108.21c-2.34,0-2.74.46-2.74,2.6V113h6.92v2.28h-6.92v2.5c0,2.13.4,2.6,2.74,2.6h4.5v2.23c-1.22,0-3.26.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.76-4,5.73-4,1.17,0,3.21,0,4.43.11v2.23Z" />
		<path d="M135.52,122.69h-3.37l-3.85-6.17-3.75,6.17h-3.22l5.44-8.54-5.24-8.24h3.33l3.58,5.82,3.61-5.82h3.15L130,114.05Z" />
		<path d="M141,122.69h-2.92V106.17a32.53,32.53,0,0,1,5.35-.43c3.7,0,6.68.73,6.68,5.23s-2.68,5.33-6.48,5.33c-.86,0-1.87,0-2.63-.09Zm0-8.76a19.67,19.67,0,0,0,2.43.11c2.42,0,3.78-.62,3.78-3.07,0-2.14-.92-3-3.69-3a19.63,19.63,0,0,0-2.52.17Z" />
		<path d="M158.5,108.21c-2.34,0-2.74.46-2.74,2.6V113h6.92v2.28h-6.92v2.5c0,2.13.4,2.6,2.74,2.6H163v2.23c-1.22,0-3.26.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.76-4,5.73-4,1.17,0,3.21,0,4.43.11v2.23Z" />
		<path d="M169.25,122.69h-2.93V106.17a32.75,32.75,0,0,1,5.36-.43c3.65,0,6.68.72,6.68,5.17,0,3.06-1.37,4.42-3.49,5l3.92,6.82h-3.4l-3.57-6.52c-.85,0-1.83,0-2.57-.09Zm0-8.9a19.67,19.67,0,0,0,2.43.11c2.37,0,3.78-.6,3.78-3,0-2.1-1-2.92-3.69-2.92a19.61,19.61,0,0,0-2.52.16Z" />
		<path d="M181.6,122.69V105.91h2.94v16.78Z" />
		<path d="M193.88,108.21c-2.34,0-2.74.46-2.74,2.6V113h6.91v2.28h-6.91v2.5c0,2.13.4,2.6,2.74,2.6h4.5v2.23c-1.23,0-3.26.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.75-4,5.73-4,1.17,0,3.2,0,4.43.11v2.23Z" />
		<path d="M212.15,119V105.91h2.62v14.82c0,1.49-.67,2.13-1.8,2.13s-1.86-.49-2.6-1.88l-6.05-11.47v13.18H201.7V107.86c0-1.49.69-2.12,1.8-2.12s1.86.49,2.59,1.87Z" />
		<path d="M228.89,108.42a21.93,21.93,0,0,0-3.3-.27c-4.51,0-4.55,2.6-4.55,6.15s0,6.15,4.55,6.15a21.93,21.93,0,0,0,3.3-.27l.26,2.22a18,18,0,0,1-4.22.46c-5.52,0-6.88-2.61-6.88-8.56s1.37-8.56,6.88-8.56a18,18,0,0,1,4.22.46Z" />
		<path d="M237.52,108.21c-2.34,0-2.74.46-2.74,2.6V113h6.92v2.28h-6.92v2.5c0,2.13.4,2.6,2.74,2.6H242v2.23c-1.22,0-3.25.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.76-4,5.73-4,1.18,0,3.21,0,4.43.11v2.23Z" />
		<path d="M261.65,105.91v2.32h-4.27v14.46h-2.94V108.23h-4.26v-2.32Z" />
		<path d="M274,122.69v-7.4h-6.87v7.4h-2.93V105.91h2.93v7H274v-7H277v16.78Z" />
		<path d="M286.32,108.21c-2.34,0-2.74.46-2.74,2.6V113h6.92v2.28h-6.92v2.5c0,2.13.4,2.6,2.74,2.6h4.5v2.23c-1.22,0-3.26.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.76-4,5.73-4,1.17,0,3.21,0,4.43.11v2.23Z" />
		<path d="M300.44,106.17a32.75,32.75,0,0,1,5.36-.43c6.26,0,7.37,2.85,7.37,8.56s-1.11,8.56-7.37,8.56a32.65,32.65,0,0,1-5.36-.44Zm2.94,14.19a12.9,12.9,0,0,0,1.95.15c4.87,0,4.9-2.69,4.9-6.21s0-6.21-4.9-6.21a14.54,14.54,0,0,0-1.95.14Z" />
		<path d="M322.08,108.21c-2.34,0-2.74.46-2.74,2.6V113h6.91v2.28h-6.91v2.5c0,2.13.4,2.6,2.74,2.6h4.5v2.23c-1.23,0-3.26.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.75-4,5.73-4,1.17,0,3.2,0,4.43.11v2.23Z" />
		<path d="M328.94,122.69l5.09-15a2.58,2.58,0,0,1,5,0l5,15H341l-1.42-4.46h-6.18L332,122.69Zm9.89-6.67-2.41-7.59L334,116Z" />
		<path d="M346.42,106.17a32.75,32.75,0,0,1,5.36-.43c6.26,0,7.37,2.85,7.37,8.56s-1.11,8.56-7.37,8.56a32.65,32.65,0,0,1-5.36-.44Zm2.93,14.19a13,13,0,0,0,1.95.15c4.87,0,4.91-2.69,4.91-6.21s0-6.21-4.91-6.21a14.67,14.67,0,0,0-1.95.14Z" />
		<path d="M375.92,118c0-1.86-1.52-2.21-3.07-2.68-3-.91-4.76-1.77-4.76-4.92,0-3.54,2.12-4.68,5.92-4.68a25.05,25.05,0,0,1,4.63.47l-.26,2.25a26.42,26.42,0,0,0-3.58-.33c-1.42,0-3.79.05-3.79,2s1.34,2.23,3.36,2.78c3.05.83,4.58,2,4.58,5,0,3.61-2.22,4.92-6.14,4.92a22.78,22.78,0,0,1-4.69-.47l.28-2.32a34.63,34.63,0,0,0,4.33.35C374.63,120.42,375.92,120,375.92,118Z" />
		<path d="M387.5,108.21c-2.34,0-2.73.46-2.73,2.6V113h6.91v2.28h-6.91v2.5c0,2.13.39,2.6,2.73,2.6H392v2.23c-1.22,0-3.25.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.76-4,5.73-4,1.18,0,3.21,0,4.43.11v2.23Z" />
		<path d="M394.37,122.69l5.09-15a2.58,2.58,0,0,1,5,0l5,15h-3.11L405,118.23h-6.18l-1.4,4.46Zm9.89-6.67-2.41-7.59L399.47,116Z" />
		<path
			d="M37,40.32a9.4,9.4,0,0,1,1.29-5.23q1.27-2,4.88-2h42.1q7.13,0,10.12,3.65t3,10.33V78.56H93.93V47.16a18.25,18.25,0,0,0-.38-3.86,8.37,8.37,0,0,0-1.38-3.16A6.55,6.55,0,0,0,89.52,38a10.25,10.25,0,0,0-4.25-.77H69.93V78.56H65.47V37.23H44.2a3.46,3.46,0,0,0-2,.51c-.49.34-.73,1.26-.73,2.74V78.56H37Z"
			fill="#58c8df"
		/>
		<path
			d="M107.65,25.22V18.54h4.8v6.68Zm.17,7.89h4.46V78.56h-4.46Z"
			fill="#58c8df"
		/>
		<path
			d="M121.71,40.32A9.4,9.4,0,0,1,123,35.09c.86-1.32,2.48-2,4.88-2H144.6q7.13,0,10.12,3.65t3,10.33V78.56h-4.46V47.16a18.93,18.93,0,0,0-.38-3.86,8.51,8.51,0,0,0-1.37-3.16A6.65,6.65,0,0,0,148.85,38a10.25,10.25,0,0,0-4.25-.77H128.91a3.46,3.46,0,0,0-2,.51c-.49.34-.73,1.26-.73,2.74V78.56h-4.46Z"
			fill="#58c8df"
		/>
		<path
			d="M181.13,78.56a15.93,15.93,0,0,1-7.76-1.68,12.31,12.31,0,0,1-4.8-4.67,20.79,20.79,0,0,1-2.45-7.07,55,55,0,0,1-.68-9,51.22,51.22,0,0,1,.9-10.16,18.44,18.44,0,0,1,3.09-7.38,13.6,13.6,0,0,1,5.95-4.5,25.33,25.33,0,0,1,9.52-1.54,32.1,32.1,0,0,1,7.8.9,16.34,16.34,0,0,1,6.22,3A13.81,13.81,0,0,1,203,41.85,20.21,20.21,0,0,1,204.45,50c0,2.64-.44,4.54-1.33,5.72s-2.61,1.76-5.19,1.76H170.07a48.42,48.42,0,0,0,.38,6A18.31,18.31,0,0,0,172,68.92a9.24,9.24,0,0,0,9.13,5.52h22.29v4.12Zm16.8-25.21a1.56,1.56,0,0,0,1.5-.68,2.75,2.75,0,0,0,.39-1.37v-.6a20.12,20.12,0,0,0-1-6.86,9.66,9.66,0,0,0-2.91-4.27,11.45,11.45,0,0,0-4.67-2.22,28.1,28.1,0,0,0-6.26-.64,25.35,25.35,0,0,0-6.6.77,9.93,9.93,0,0,0-4.68,2.69A11.83,11.83,0,0,0,171,45.29a30.33,30.33,0,0,0-.9,8.06Z"
			fill="#58c8df"
		/>
		<path
			d="M212.17,48.72q0-7.8,3.69-11.71t11.48-3.9h3.09v4.12h-3.09q-5.82,0-8.27,3.08t-2.44,9.5V78.56h-4.46Z"
			fill="#58c8df"
		/>
		<path
			d="M257.27,33.11q5.66,0,8.27,3t2.62,8.41v28a7,7,0,0,1-1.24,4.51q-1.25,1.5-5.36,1.5H244.07q-6.78,0-9.52-3.3T231.8,64.84q0-7.12,2.79-10.29t9.48-3.17H263.7V43.79a7.69,7.69,0,0,0-1.42-4.56q-1.41-2-5-2h-22V33.11ZM242.86,55.49a6.92,6.92,0,0,0-3.3.68,5.08,5.08,0,0,0-2,2,8,8,0,0,0-.94,3,30.5,30.5,0,0,0-.22,3.74,31.55,31.55,0,0,0,.22,3.78,8.45,8.45,0,0,0,.94,3.06,5.23,5.23,0,0,0,2,2,6.56,6.56,0,0,0,3.3.72h18.7a1.94,1.94,0,0,0,1.67-.64,2.31,2.31,0,0,0,.47-1.4V55.49Z"
			fill="#58c8df"
		/>
		<path d="M277.42,18.54h4.46v60h-4.46Z" fill="#58c8df" />
		<path d="M356,72.9q.18.43.39.9c.14.31.33.47.56.47s.48-.18.6-.56a4.43,4.43,0,0,1,.26-.72l9.52-36.72c.45-1.6,1.11-2.62,2-3a4.45,4.45,0,0,1,4.63,0c.86.42,1.52,1.44,2,3L385.47,73a6.31,6.31,0,0,1,.25.72c.12.38.32.56.6.56s.42-.16.56-.47.27-.61.39-.9l10.21-39.8h4.46L390.78,75.3a7.8,7.8,0,0,1-1.32,2.62,3.66,3.66,0,0,1-3,1.15,4.64,4.64,0,0,1-2.06-.42,4.36,4.36,0,0,1-1.37-1,5.22,5.22,0,0,1-.81-1.25,4,4,0,0,1-.39-1.15L372.51,39.7a9.6,9.6,0,0,0-.38-1.11c-.15-.35-.3-.52-.47-.52s-.33.17-.48.52a9.6,9.6,0,0,0-.38,1.11l-9.27,35.52c-.11.34-.25.72-.42,1.15a4.54,4.54,0,0,1-.78,1.25,4.41,4.41,0,0,1-1.33,1,4.56,4.56,0,0,1-2.1.42,3.62,3.62,0,0,1-3-1.15,7.82,7.82,0,0,1-1.33-2.62L341.38,33.1h4.46Z" />
		<path d="M406.57,19.17h4.8v6.69h-4.8Zm.17,13.93h4.46V78.56h-4.46Z" />
		<path d="M420.63,40.3a9.44,9.44,0,0,1,1.29-5.23q1.29-2,4.89-2h42.12q7.11,0,10.12,3.64t3,10.34V78.56h-4.46V47.14a18.9,18.9,0,0,0-.38-3.85,8.48,8.48,0,0,0-1.38-3.17A6.53,6.53,0,0,0,473.18,38a10.12,10.12,0,0,0-4.25-.78H453.57V78.56h-4.46V37.21H427.84a3.49,3.49,0,0,0-2,.52c-.48.34-.72,1.25-.72,2.74V78.56h-4.47Z" />
		<polygon points="490.57 43.74 490.57 34.29 487.04 34.29 487.04 33.02 495.54 33.02 495.54 34.29 491.99 34.29 491.99 43.74 490.57 43.74" />
		<path d="M497,43.75V33h2.14l2.54,7.59.51,1.59c.12-.39.31-1,.57-1.72L505.28,33h1.91V43.75h-1.37v-9l-3.12,9h-1.28l-3.1-9.14v9.14Z" />
		<path d="M322.4,4.35c-.55.6-1.08,1.08-1.53,1.66a18.43,18.43,0,0,0-3.7,13.34A22.37,22.37,0,0,0,319.9,28a78,78,0,0,0,5.38,8.36,97,97,0,0,1,7.33,11.78,18.83,18.83,0,0,1,2.22,9.74,16.88,16.88,0,0,1-2.56,7.93,17.55,17.55,0,0,1-2.62,3.35c-.1-.26.05-.33.12-.43a15.8,15.8,0,0,0,2.6-8.86,16.53,16.53,0,0,0-1.41-6.1,34.82,34.82,0,0,0-4.88-7.94c-2.57-3.29-5.37-6.29-8.11-9.36a74.23,74.23,0,0,1-6.38-7.93,25,25,0,0,1-3.16-6.18,13.28,13.28,0,0,1,.29-9.37,13.13,13.13,0,0,1,7.78-7.77,15.16,15.16,0,0,1,5.59-.84Z" />
		<path
			d="M309.6,80.25a14.44,14.44,0,0,0,3.31-4.37,19.55,19.55,0,0,0,.94-15.24,31.84,31.84,0,0,0-3.7-7.32c-1.68-2.62-3.49-5.1-5.23-7.66a78.49,78.49,0,0,1-5.62-9.35c-2.53-5.15-2.89-10.27-.68-15.32a18.83,18.83,0,0,1,3.67-5.42c.06-.06.11-.15.25-.09a27.09,27.09,0,0,0-1.4,2.53,14.78,14.78,0,0,0-.83,10.83A24.79,24.79,0,0,0,303.22,35a50.12,50.12,0,0,0,3.38,4.67c2.37,2.94,4.9,5.66,7.38,8.45a78.92,78.92,0,0,1,5.6,6.79,28.45,28.45,0,0,1,3.73,6.61,13.28,13.28,0,0,1,.14,9.74,13.07,13.07,0,0,1-7.63,8,14.66,14.66,0,0,1-5.9,1Z"
			fill="#58c8df"
		/>
	</svg>
)

export const EcoSwimTag = props => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 389.04 141.73"
		fill="currentColor"
		{...props}
	>
		<title>Eco Swim - Next-Gen Chlorination</title>
		<path d="M65.25,119V105.91h2.62v14.82c0,1.49-.67,2.13-1.8,2.13s-1.86-.49-2.6-1.88l-6-11.47v13.18H54.8V107.86c0-1.49.69-2.12,1.8-2.12s1.86.49,2.59,1.87Z" />
		<path d="M77.22,108.21c-2.34,0-2.74.46-2.74,2.6V113H81.4v2.28H74.48v2.5c0,2.13.4,2.6,2.74,2.6h4.5v2.23c-1.22,0-3.26.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.76-4,5.73-4,1.17,0,3.21,0,4.43.11v2.23Z" />
		<path d="M98.38,122.69H95l-3.85-6.17-3.75,6.17H84.19l5.44-8.54-5.24-8.24h3.33l3.58,5.82,3.61-5.82h3.15l-5.19,8.14Z" />
		<path d="M111.69,105.91v2.32h-4.27v14.46h-2.94V108.23h-4.26v-2.32Z" />
		<path d="M112,115.45v-2.3h6.22v2.3Z" />
		<path d="M133.16,108.43a30.26,30.26,0,0,0-4.33-.28c-4.5,0-4.54,2.6-4.54,6.15s0,6.15,4.54,6.15c2,0,2.11-.61,2.11-1.48v-3.23h-2.88V113.5h5.76v6.28c0,2.89-2.39,3.08-5.64,3.08-5.51,0-6.89-2.61-6.89-8.56s1.38-8.56,6.89-8.56a27.39,27.39,0,0,1,5.23.45Z" />
		<path d="M142.79,108.21c-2.34,0-2.74.46-2.74,2.6V113H147v2.28h-6.92v2.5c0,2.13.4,2.6,2.74,2.6h4.5v2.23c-1.22,0-3.26.11-4.43.11-3,0-5.73-.16-5.73-4v-8.94c0-3.81,2.76-4,5.73-4,1.17,0,3.21,0,4.43.11v2.23Z" />
		<path d="M161.06,119V105.91h2.62v14.82c0,1.49-.66,2.13-1.8,2.13s-1.86-.49-2.59-1.88l-6.06-11.47v13.18h-2.62V107.86c0-1.49.69-2.12,1.81-2.12s1.85.49,2.58,1.87Z" />
		<path d="M184.1,108.42a21.93,21.93,0,0,0-3.3-.27c-4.51,0-4.54,2.6-4.54,6.15s0,6.15,4.54,6.15a21.93,21.93,0,0,0,3.3-.27l.26,2.22a17.93,17.93,0,0,1-4.21.46c-5.53,0-6.89-2.61-6.89-8.56s1.37-8.56,6.89-8.56a17.93,17.93,0,0,1,4.21.46Z" />
		<path d="M197,122.69v-7.4H190.1v7.4h-2.93V105.91h2.93v7H197v-7h2.94v16.78Z" />
		<path d="M206.57,117.79c0,2.13.4,2.6,2.74,2.6h4.21v2.24c-1.24.05-3.06.1-4.15.1-3,0-5.73-.16-5.73-4V105.91h2.93Z" />
		<path d="M221.9,122.86c-5.17,0-6.65-2.48-6.65-8.56s1.48-8.56,6.65-8.56,6.64,2.48,6.64,8.56S227.07,122.86,221.9,122.86Zm0-2.37c3.57,0,3.68-2.53,3.68-6.19s-.11-6.2-3.68-6.2-3.66,2.53-3.66,6.2S218.33,120.49,221.9,120.49Z" />
		<path d="M234.81,122.69h-2.93V106.17a32.75,32.75,0,0,1,5.36-.43c3.64,0,6.68.72,6.68,5.17,0,3.06-1.37,4.42-3.5,5l3.93,6.82h-3.41l-3.56-6.52c-.85,0-1.83,0-2.57-.09Zm0-8.9a19.58,19.58,0,0,0,2.43.11c2.37,0,3.77-.6,3.77-3,0-2.1-1-2.92-3.68-2.92a19.49,19.49,0,0,0-2.52.16Z" />
		<path d="M247.16,122.69V105.91h2.94v16.78Z" />
		<path d="M264.32,119V105.91h2.62v14.82c0,1.49-.66,2.13-1.8,2.13s-1.86-.49-2.6-1.88l-6.05-11.47v13.18h-2.62V107.86c0-1.49.69-2.12,1.8-2.12s1.86.49,2.59,1.87Z" />
		<path d="M269.41,122.69l5.09-15a2.58,2.58,0,0,1,5,0l5,15h-3.11L280,118.23h-6.18l-1.4,4.46ZM279.3,116l-2.41-7.59L274.51,116Z" />
		<path d="M295.74,105.91v2.32h-4.27v14.46h-2.94V108.23h-4.26v-2.32Z" />
		<path d="M298.29,122.69V105.91h2.94v16.78Z" />
		<path d="M311.19,122.86c-5.17,0-6.65-2.48-6.65-8.56s1.48-8.56,6.65-8.56,6.64,2.48,6.64,8.56S316.36,122.86,311.19,122.86Zm0-2.37c3.57,0,3.67-2.53,3.67-6.19s-.1-6.2-3.67-6.2-3.66,2.53-3.66,6.2S307.62,120.49,311.19,120.49Z" />
		<path d="M331.62,119V105.91h2.61v14.82c0,1.49-.66,2.13-1.8,2.13s-1.85-.49-2.59-1.88l-6.06-11.47v13.18h-2.61V107.86c0-1.49.68-2.12,1.8-2.12s1.86.49,2.59,1.87Z" />
		<path d="M229,73.46c.12.29.25.6.4.91s.33.48.56.48.5-.18.61-.56a5.33,5.33,0,0,1,.27-.74l9.68-37.35c.47-1.63,1.13-2.66,2-3.1a4.59,4.59,0,0,1,4.71,0,4.71,4.71,0,0,1,2,3.1L259,73.55a5.81,5.81,0,0,1,.26.74c.12.38.32.56.61.56s.42-.16.57-.48.28-.62.39-.91L271.19,33h4.53L264.38,75.9A7.87,7.87,0,0,1,263,78.56a3.69,3.69,0,0,1-3.1,1.18,4.61,4.61,0,0,1-2.09-.44,4.41,4.41,0,0,1-1.4-1,5.43,5.43,0,0,1-.83-1.27,4.91,4.91,0,0,1-.39-1.18L245.8,39.69a9.92,9.92,0,0,0-.4-1.13c-.14-.35-.3-.53-.48-.53s-.33.18-.48.53-.27.72-.39,1.13l-9.42,36.12c-.12.35-.26.74-.44,1.18a4.41,4.41,0,0,1-.78,1.27,4.37,4.37,0,0,1-3.49,1.48,3.68,3.68,0,0,1-3.1-1.18,7.87,7.87,0,0,1-1.35-2.66L214.12,33h4.54Z" />
		<path d="M280.43,18.81h4.89v6.81h-4.89ZM280.61,33h4.54V79.22h-4.54Z" />
		<path d="M294.74,40.3A9.63,9.63,0,0,1,296.05,35q1.31-2,5-2h42.84q7.23,0,10.29,3.71t3.06,10.51v32h-4.54v-32a18.81,18.81,0,0,0-.39-3.92,8.67,8.67,0,0,0-1.4-3.22,6.76,6.76,0,0,0-2.71-2.18,10.35,10.35,0,0,0-4.31-.78H328.25V79.22h-4.54V37.16H302.07a3.59,3.59,0,0,0-2.05.52c-.49.35-.74,1.28-.74,2.79V79.22h-4.54Z" />
		<path d="M194.82,3.73c-.56.61-1.09,1.1-1.56,1.69A18.79,18.79,0,0,0,189.5,19a22.48,22.48,0,0,0,2.78,8.74,79.15,79.15,0,0,0,5.47,8.51,98.32,98.32,0,0,1,7.46,12,19.15,19.15,0,0,1,2.25,9.91,17.08,17.08,0,0,1-2.59,8.06,17.57,17.57,0,0,1-2.67,3.41c-.1-.26.05-.33.11-.44a16,16,0,0,0,2.65-9,16.91,16.91,0,0,0-1.43-6.2,35.17,35.17,0,0,0-5-8.07c-2.62-3.36-5.46-6.4-8.25-9.53a74.92,74.92,0,0,1-6.5-8.07,24.78,24.78,0,0,1-3.2-6.28,13.45,13.45,0,0,1,.29-9.53,13.39,13.39,0,0,1,7.91-7.91,15.44,15.44,0,0,1,5.68-.85Z" />
		<path
			d="M181.8,80.93a14.36,14.36,0,0,0,3.37-4.44,19.9,19.9,0,0,0,1-15.51,32.09,32.09,0,0,0-3.76-7.44c-1.71-2.66-3.55-5.19-5.31-7.79a78.56,78.56,0,0,1-5.72-9.51c-2.58-5.24-2.94-10.44-.69-15.59a19.39,19.39,0,0,1,3.73-5.51c.06-.06.11-.15.25-.09-.5.85-1,1.68-1.43,2.57a15.08,15.08,0,0,0-.84,11,25.7,25.7,0,0,0,3,6.28,48.57,48.57,0,0,0,3.43,4.74c2.41,3,5,5.76,7.51,8.6A81.64,81.64,0,0,1,192,55.17a28.92,28.92,0,0,1,3.8,6.73,13.55,13.55,0,0,1,.14,9.9A13.3,13.3,0,0,1,188.13,80a15,15,0,0,1-6,1A2.64,2.64,0,0,1,181.8,80.93Z"
			fill="#58c8df"
		/>
		<path
			d="M181.84,80.91a14.45,14.45,0,0,0,3.36-4.43,19.84,19.84,0,0,0,1-15.47,32.31,32.31,0,0,0-3.75-7.42c-1.71-2.66-3.54-5.18-5.31-7.77a80.29,80.29,0,0,1-5.7-9.49c-2.57-5.23-2.94-10.42-.69-15.55a19.17,19.17,0,0,1,3.72-5.5c.06-.06.11-.15.25-.09a29,29,0,0,0-1.42,2.57,15,15,0,0,0-.84,11,25.18,25.18,0,0,0,3,6.26,46.73,46.73,0,0,0,3.42,4.73c2.4,3,5,5.75,7.5,8.58A82.74,82.74,0,0,1,192,55.21a29.54,29.54,0,0,1,3.79,6.71,13.55,13.55,0,0,1,.15,9.88A13.28,13.28,0,0,1,188.15,80a14.74,14.74,0,0,1-6,1A2.35,2.35,0,0,1,181.84,80.91Z"
			fill="#58c8df"
		/>
		<path
			d="M46.92,79.18a16.13,16.13,0,0,1-7.87-1.7,12.47,12.47,0,0,1-4.87-4.74,20.85,20.85,0,0,1-2.48-7.18,54.15,54.15,0,0,1-.7-9.09,52,52,0,0,1,.91-10.31,18.74,18.74,0,0,1,3.14-7.48,13.88,13.88,0,0,1,6-4.57,25.8,25.8,0,0,1,9.66-1.56,32.6,32.6,0,0,1,7.92.91,16.66,16.66,0,0,1,6.31,3,14,14,0,0,1,4.13,5.46,20.39,20.39,0,0,1,1.48,8.25c0,2.68-.45,4.61-1.35,5.81S66.59,57.78,64,57.78H35.7a47.93,47.93,0,0,0,.39,6.07,18.32,18.32,0,0,0,1.57,5.56A9.41,9.41,0,0,0,46.92,75H69.54v4.17ZM64,53.6a1.59,1.59,0,0,0,1.52-.69,2.79,2.79,0,0,0,.39-1.39v-.6a20.45,20.45,0,0,0-1-7,9.8,9.8,0,0,0-3-4.33,11.41,11.41,0,0,0-4.74-2.25,28.26,28.26,0,0,0-6.35-.65,25.69,25.69,0,0,0-6.7.78,10.05,10.05,0,0,0-4.74,2.73,12.06,12.06,0,0,0-2.79,5.19,30.79,30.79,0,0,0-.91,8.18Z"
			fill="#58c8df"
		/>
		<path
			d="M96.34,79.18a26.08,26.08,0,0,1-9.66-1.52,13.89,13.89,0,0,1-6-4.44,17,17,0,0,1-3-7.22,52.84,52.84,0,0,1-.83-9.88,50,50,0,0,1,.83-9.48,17.66,17.66,0,0,1,3-7.26,14.49,14.49,0,0,1,6-4.66,24.17,24.17,0,0,1,9.66-1.65h15.49v4.17H96.34a18.79,18.79,0,0,0-7.48,1.26,10.19,10.19,0,0,0-4.48,3.64,14.75,14.75,0,0,0-2.22,5.93,47.54,47.54,0,0,0-.61,8,50,50,0,0,0,.61,8.41,14.5,14.5,0,0,0,2.22,5.89,9.53,9.53,0,0,0,4.48,3.46A20.81,20.81,0,0,0,96.34,75h16.53v4.17Z"
			fill="#58c8df"
		/>
		<path
			d="M138.45,32.55A36.2,36.2,0,0,1,149,33.89a16.28,16.28,0,0,1,7.09,4.22,16.79,16.79,0,0,1,4,7.31A40.6,40.6,0,0,1,161.25,56,41,41,0,0,1,160,66.69a16.81,16.81,0,0,1-4,7.36A16.63,16.63,0,0,1,149,78.31a34.77,34.77,0,0,1-10.53,1.39,34.77,34.77,0,0,1-10.53-1.39,16.63,16.63,0,0,1-7.09-4.26,17,17,0,0,1-4-7.36A41,41,0,0,1,115.66,56a40.63,40.63,0,0,1,1.21-10.62,17,17,0,0,1,4-7.31,16.28,16.28,0,0,1,7.09-4.22A36.2,36.2,0,0,1,138.45,32.55ZM120.35,56a36.77,36.77,0,0,0,1,9.27,13.81,13.81,0,0,0,3.18,6,11.88,11.88,0,0,0,5.61,3.24,36.45,36.45,0,0,0,16.62,0,11.88,11.88,0,0,0,5.61-3.24,13.81,13.81,0,0,0,3.18-6,36.31,36.31,0,0,0,1-9.27,35.77,35.77,0,0,0-1-9.23,13.46,13.46,0,0,0-3.18-5.93,12.17,12.17,0,0,0-5.61-3.21,36.82,36.82,0,0,0-16.62,0,12.17,12.17,0,0,0-5.61,3.21,13.46,13.46,0,0,0-3.18,5.93A36.21,36.21,0,0,0,120.35,56Z"
			fill="#58c8df"
		/>
		<path d="M366.87,33a5.18,5.18,0,1,1-5.18,5.17A5.14,5.14,0,0,1,366.87,33Zm0,1A4.17,4.17,0,1,0,371,38.14,4.09,4.09,0,0,0,366.87,34ZM366,41h-1.1V35.08H367c1.66,0,2.31.64,2.31,1.74a1.54,1.54,0,0,1-1.18,1.61L369.39,41h-1.24L367,38.59h-1Zm0-5v1.66h.89c.93,0,1.35-.26,1.35-.85s-.45-.81-1.38-.81Z" />
	</svg>
)
